// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/style/base.css
// module id = 2
// module chunks = 32